// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"3515b9c0","266":"501e4abe","344":"70a06e67","438":"e92b0a22","921":"8a758098","966":"6f995ce2","984":"459aa561"}[chunkId] + ".chunk.js";
};